import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '@/api/common';

import type { Admin } from './types';

type Variables = void;
type Response = Admin;

// 401/403 is the expected response for plain customers and self-provisioned
// partners without an org, so don't retry on failure.
export const useAdmin = createQuery<Response, Variables, AxiosError>({
  queryKey: ['internal/partners/admins/me'],
  fetcher: () => {
    return client
      .get('v2/internal/partners/admins/me')
      .then((response) => response.data.data);
  },
  retry: false,
});
